import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ClockIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

const RegistrationPending = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="p-4 bg-yellow-100 rounded-full">
            <ClockIcon className="h-16 w-16 text-yellow-600" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          Registration Pending Approval
        </h1>
        
        <p className="text-gray-600 mb-6">
          Thank you for registering your business with BookFlow. Our team will review your application and you will receive an email once approved.
        </p>
        
        <div className="bg-blue-50 rounded-lg p-4 mb-6 text-left">
          <div className="flex items-start">
            <EnvelopeIcon className="h-5 w-5 text-blue-600 mr-2 mt-0.5" />
            <div>
              <p className="text-sm text-blue-800 font-medium">What happens next?</p>
              <p className="text-sm text-blue-700 mt-1">
                1. Admin reviews your application<br />
                2. You receive approval email<br />
                3. Login to set up your business<br />
                4. Start accepting bookings!
              </p>
            </div>
          </div>
        </div>
        
        <button
          onClick={() => navigate('/login')}
          className="w-full btn-primary"
        >
          Go to Login
        </button>
        
        <p className="text-sm text-gray-500 mt-4">
          This process usually takes 24-48 hours.
        </p>
      </div>
    </div>
  );
};

export default RegistrationPending;